import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import axios from 'axios';

function ShibaPage() {
  const [shibaList, setShibaList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPredictions = async () => {
    try {
      // const res = await axios.get("http://127.0.0.1:8000/api/predictions");
      const res = await axios.get('/api/predictions');
      setShibaList(res.data);
    } catch (error) {
      console.error('データ取得失敗:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPredictions();
  }, []);

  if (loading) {
    return <div>読み込み中...</div>;
  }

  return (
    <Box
      p={4}
      sx={{
        width: { xs: '100%', sm: 'auto' },
        padding: '5px',
      }}
    >
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          fontSize: { xs: '1.5rem', sm: '2.125rem' },
        }}
      >
        開発者 推奨買い目
      </Typography>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={cellStyle}>レース情報</TableCell>
              <TableCell sx={cellStyle}>券種</TableCell>
              <TableCell sx={cellStyle}>買い方</TableCell>
              <TableCell sx={cellStyle}>購入金額</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {shibaList.map((shiba, index) => (
              <TableRow key={index}>
                <TableCell sx={childCellStyle}>{shiba.race_info}</TableCell>
                <TableCell sx={childCellStyle}>{shiba.type_item}</TableCell>
                <TableCell sx={childCellStyle}>{shiba.type_horse}</TableCell>
                <TableCell sx={childCellStyle}>{shiba.payment}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

// 共通スタイルを外出し
const cellStyle = {
  fontSize: { xs: '0.7rem', sm: '0.8rem' },
  padding: '3px',
  textAlign: 'center',
};

const childCellStyle = {
  fontSize: { xs: '1.2rem', sm: '0.8rem' },
  padding: '3px',
  textAlign: 'center',
};

export default ShibaPage;
